import Topology1Dimm from '@images/memory/topology1Dimm.svg';
import TopologyDaisyChain from '@images/memory/topologyDaisyChain.svg';
import TopologyT from '@images/memory/topologyT.svg';
import * as React from 'react';
export default {
  Topology1Dimm,
  TopologyDaisyChain,
  TopologyT,
  React
};